export default "__VITE_ASSET__C3cY0CiW__"